import IbssTextField from '../../../../../Components/Inputs/TextField/IbssTextField';
import IbssCheckBox from '../../../../../Components/Inputs/CheckBox/IbssCheckBox';
import IbssInputDropDown from '../../../../../Components/Inputs/SelectList/IbssInputDropDown';
import { IconButton } from '@mui/material';
import Bin from '../../../../../Components/Icons/Bin';
import IbssButton from '../../../../../Components/Buttons/Button/IbssButton';
import { appContext } from '../../../../../AppContext';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';

class MultiOptionSelectForm extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            helperTextChecked: false
        };
    };

    public componentDidMount(): void
    {
        this.setState({ helperTextChecked: this.props.helperText.length > 0 });
    }

    private helperTextCheckboxSelected(checked: boolean): void
    {
        this.setState({ helperTextChecked: checked });
        if (checked == false)
        {
            this.props.onHelperTextChange('');
        }
    }

    public render(): JSX.Element
    {
        return (
            <div>
                <div className='m-4'>
                    <IbssTextField required value={this.props.questionName} className='mb-1' fullWidth variant='standard' label={this.labels.funcVisitorTypeQuestionName_S} onChange={(e) => this.props.onQuestionNameChange(e.target.value)} maxLength={500} />
                    <IbssCheckBox checked={this.state.helperTextChecked} label={this.labels.funcVisitorTypeHelperText_S} onClicked={(e: { target: { checked: boolean; }; }) => this.helperTextCheckboxSelected(e.target.checked)} />
                    {
                        this.state.helperTextChecked &&
                        <IbssTextField value={this.props.helperText} fullWidth variant='standard' label={this.labels.funcVisitorTypeHelperText_S} onChange={(e) => this.props.onHelperTextChange(e.target.value)} />
                    }
                </div>
                <hr />
                <div className='m-4'>
                    {
                        this.props.answerOptions.map((x, index) => (
                            <div className='d-flex' style={{ justifyContent: 'space-between' }}>
                                <div style={{ width: '40%', alignContent: 'center' }}>
                                    <IbssTextField required value={x.label} className='mb-1' fullWidth variant='standard' label={this.labels.HubLabelLabel} onChange={(e) => this.props.onOptionLabelChange(index, e.target.value)} />
                                </div>
                                <div style={{ width: '60%' }} className='d-flex'>
                                    <div style={{ width: '30%', alignContent: 'center' }} className='ml-2'>{this.labels.funcVisitorTypesGoto_S}:</div>
                                    <IbssInputDropDown value={x.goto} onChange={(e) => this.props.gotoValueChanged(index, e.target.value)} id='stepOptions' options={[...this.props.steps, { label: this.labels.funcVisitorTypesNext_S, value: 'next' }]} />
                                    <div style={{ width: '20%', alignContent: 'center' }}>
                                        <IconButton disabled={this.props.answerOptions.length == 1} className='mr-2' onClick={() => this.props.onDeleteOption(index)}><Bin /></IconButton>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div style={{ textAlign: 'center' }}>
                    <IbssButton className='mb-4' color='primary' onClick={() => this.props.onAddNewOption()}>{this.labels.funcVisitorTypesAddOption_S}</IbssButton>
                </div>
            </div>
        )
    }
}

export default MultiOptionSelectForm;

export interface IProps
{
    answerOptions: IAnswerOptions[];
    steps: IDropdownOptions[];
    onQuestionNameChange: (value: string) => void;
    questionName: string;
    onHelperTextChange: (value: string) => void;
    helperText: string;
    gotoValueChanged: (index: number, gotot: string) => void;
    onOptionLabelChange: (index: number, gotot: string) => void;
    onDeleteOption: (index: number) => void;
    onAddNewOption: () => void;
}

export interface IState
{
    helperTextChecked: boolean;
}

export interface IAnswerOptions
{
    label: string;
    goto: string;
}

export interface IDropdownOptions
{
    label: string;
    value: string;
}